import React from 'react';
import { useSelector} from 'react-redux';
import {ProfileBeaconModal} from "../ProfileBeaconComponents";
import styled from 'styled-components';
import {selectedModalName} from "../../../redux/modal/selectors";

const StyledButtonContainer = styled.div`
  display: inline;
`;

const StyledActionZone= styled.div`   
  margin:0px;
  #modal-footer{
    padding-right:24px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 0px;
    @media (max-width: 768px) {
      padding-bottom: 16px;
      padding-right: 17px;
      padding-top: 16px;   
    }
    
  }
`;

const StyledModalContainer = styled.div`
`;

const StyledBeaconModal = styled(ProfileBeaconModal)`
  z-index: 999999;
  --beacon-modal-title-space-padding: 0;
  --beacon-modal-action-zone-space-padding:0;
`;

export const BeaconModal = ({id,footer, children, actionZone }) => {
    const modalName = useSelector(selectedModalName);

    return (
        <StyledModalContainer data-metrics-location="PU">
        <StyledBeaconModal id={id}
                           scale='jumbo'
                           elevation='3'
                           open={!!modalName}
                           closeOnClickOut="true"
        >
            {children}
            {actionZone?
                <StyledActionZone className="action-zone-align-right" slot="action-zone">
                        {footer}
                </StyledActionZone>
                :
                <StyledButtonContainer>
                     {footer}
                 </StyledButtonContainer>
            }
        </StyledBeaconModal>
        </StyledModalContainer>
    );

}